<script>
	import { Line, mixins } from 'vue-chartjs';

	export default {
		extends: Line,
		mixins: [mixins.reactiveProp],
		watch: {
			chartData() {
				this.$data._chart.update();
			},
		},
		props: {
			chartData: {
				type: Object,
				default: null,
			},
			options: {
				type: Object,
				default: null,
			},
		},
		mounted() {
			this.renderChart(this.chartData, this.options);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/components/chart-bar.vue